import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken, setToken, removeToken } from "@/helpers/cookiesHelper";
import { logout } from "../slice/authSlice";
import { Mutex } from "async-mutex";

const mutex = new Mutex();

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_BASE_URL,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) headers.set("authorization", `Bearer ${token}`);
    return headers;
  },
});

export const baseQueryWithReauth: typeof baseQuery = async (args, api, extraOptions) => {
  await mutex.waitForUnlock();
  let result = await baseQuery(args, api, extraOptions);

  if (result.error?.status === 401) {
    const token = getToken();
    const state = api.getState() as { auth: { user: unknown } };
    if (!token && !state.auth?.user) {
      return result;
    }

    if (!mutex.isLocked()) {
      const release = await mutex.acquire();

      try {
        const refreshResult = await baseQuery(
          { url: "/auth/refresh", method: "POST" },
          api,
          extraOptions
        );

        if (refreshResult.data) {
          const { token: newToken } = refreshResult.data as { token: string };
          setToken(newToken);

          result = await baseQuery(args, api, extraOptions);
        } else {
          removeToken();
          api.dispatch(logout());
          window.location.href = "/login";
        }
      } finally {
        release();
      }
    } else {
      await mutex.waitForUnlock();
      result = await baseQuery(args, api, extraOptions);
    }
  }

  return result;
};
